import { useState, useEffect } from "react";
import { arrayOf, string, shape } from "prop-types";
import HighlightText from "../../../../Common/js/components/HighlightText/HighlightText.jsx";

import MagnifyingGlassIcon from "../Icon/MagnifyingGlassIcon.jsx";

const propTypes = {
  placeholder: string,
  visualizations: arrayOf(
    shape({
      title: string,
      image: string,
      locations: arrayOf(
        shape({
          href: string,
          text: string,
        }),
      ),
    }),
  ),
};

const VisualizationFinder = (props) => {
  const { placeholder, visualizations } = props;

  const [query, setQuery] = useState("");
  const results = visualizations.filter((item) =>
    RegExp(query, "ig").test(item.title),
  );

  return (
    <section className="visualization-finder">
      <div className="visualization-finder__search-container">
        <MagnifyingGlassIcon width="20" height="20" />
        <input
          type="text"
          className="visualization-finder__search-text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
        />
      </div>
      <div className="visualization-finder__item-container">
        {results.map((item, index, arr) => {
          return (
            // keyboard navigation is handled via the figcaption button
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
            <figure
              className="visualization-item"
              key={index + item.title}
              onClick={() => {
                window.openGlobalModal(item.modalTarget);
              }}
            >
              <figcaption>
                <button className="visualization-item__title" type="button">
                  <HighlightText query={query} text={item.title} />
                </button>
              </figcaption>
              <img
                className="visualization-item__img"
                src={item.image}
                alt={item.title}
              />
            </figure>
          );
        })}
      </div>
    </section>
  );
};

VisualizationFinder.propTypes = propTypes;
export default VisualizationFinder;
